import { OnlineSales } from 'gw-edge-client';
import { useAsyncThrow } from '../../hooks/useAsyncThrow';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import type { ConflictingCoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';

export const useCheckCoverableForDoubleInsurance = (): {
    checkCoverableForDoubleInsurance: (
        linePrefix: string,
        coverableFixedId: string,
        accountNumber: string
    ) => Promise<ConflictingCoverableDTO>;
} => {
    const { asyncThrow } = useAsyncThrow<ConflictingCoverableDTO>();
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const checkCoverableForDoubleInsurance = async (
        linePrefix: string,
        coverableFixedId: string,
        accountNumber: string
    ): Promise<ConflictingCoverableDTO> => {
        return await OnlineSales.checkCoverableForDoubleInsurance(
            jobNumber,
            linePrefix,
            coverableFixedId,
            accountNumber,
            sessionId
        ).catch(asyncThrow);
    };

    return { checkCoverableForDoubleInsurance };
};
